
export const INSERT_FA_DETAILS = 'INSERT_FA_DETAILS';
export const INSERT_TOKEN = 'INSERT_TOKEN';
export const INSERT_FA_POOLS_LIST = 'INSERT_FA_POOLS_LIST';
export const INSERT_ENV_VARIABLES = 'INSERT_ENV_VARIABLES';
export const REFRESH = 'REFRESH_APP';
export const INSERT_FA_PREFERENCE = 'INSERT_FA_PREFERENCE';
export const INSERT_ADVISOR_HANDLE = 'INSERT_ADVISOR_HANDLES';
export const SET_SELECTED_ADVISORHANDLE = 'SET_SELECTED_ADVISOR_HANDLE'